<div class="container">
  <div class="content">
    <div class="display">
      <!-- <div class="logo">
        <img src="../assets/ngx-editor.svg" />
        <div class="subtitle">Rich Text Editor for angular using ProseMirror</div>
      </div> -->
    </div>

    <form [formGroup]="form">
      <div class="editor">
        <ngx-editor-menu [editor]="editor" [toolbar]="toolbar">
        </ngx-editor-menu>
        <ngx-editor [editor]="editor" formControlName="editorContent">
        </ngx-editor>
      </div>
    </form>

    <!-- <div class="editor">
      <ngx-editor [editor]="editor" [(ngModel)]="editordoc">
      </ngx-editor>
    </div> -->
  </div>
</div>
